var s = (r, t, m) => new Promise((a, i) => {
  var n = (o) => {
    try {
      y(m.next(o));
    } catch (e) {
      i(e);
    }
  }, p = (o) => {
    try {
      y(m.throw(o));
    } catch (e) {
      i(e);
    }
  }, y = (o) => o.done ? a(o.value) : Promise.resolve(o.value).then(n, p);
  y((m = m.apply(r, t)).next());
});
import { selfAxios as c } from "@oppein/op-utils";
function d(r) {
  return s(this, null, function* () {
    const {
      data: t
    } = yield c.post(
      "/bsplatform/commodity/queryCommodityByPageFromES",
      r
    );
    return t == null ? void 0 : t.data;
  });
}
export {
  d as postQueryCommodityByPageFromES
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/bsplatform/commodity/queryCommodityByPageFromES/post.js
// module id = 1798
// module chunks = 67